export default "__VITE_ASSET__X5SpZy3Q__"